import { useLocale } from '@/providers/LocaleProvider';
import ChevronRightIcon from '@/resources/images/icons-chevron-right.svg';
import { KLAYO_COLORS } from '@/themes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const COLLAPSED_STORAGE_KEY = 'klayo:exploreTeaser:collapsed';

export const ExploreKlayoTeaser = () => {
  const { translate } = useLocale();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(
    () => localStorage.getItem(COLLAPSED_STORAGE_KEY) !== 'true'
  );

  const handleChange = (_: React.SyntheticEvent, isExpanded: boolean) => {
    localStorage.setItem(COLLAPSED_STORAGE_KEY, String(!isExpanded));
    setExpanded(isExpanded);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange}
      disableGutters
      elevation={0}
      sx={{
        borderRadius: '0 !important',
        bgcolor: `${KLAYO_COLORS.NeonBlueNB050} !important`,
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: KLAYO_COLORS.GreyGR400 }} />}
        sx={{
          px: 3,
          py: 0,
          minHeight: 'unset',
          '& .MuiAccordionSummary-content': { my: 2 },
          '& .MuiAccordionSummary-expandIconWrapper': { transform: 'rotate(180deg)' },
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(0deg)' },
        }}
      >
        <Typography
          sx={{
            fontSize: '14px !important',
            fontWeight: '600 !important',
            color: `${KLAYO_COLORS.GreyGR600} !important`,
          }}
        >
          {translate('exploreKlayoTeaser.title')}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ px: 3, pt: 0, pb: 2 }}>
        <Stack gap={1}>
          <Typography variant='body2' fontWeight={400} color={KLAYO_COLORS.GreyGR700}>
            {translate('exploreKlayoTeaser.description')}
          </Typography>
          <Stack
            direction='row'
            alignItems='center'
            gap={0.5}
            onClick={() => navigate('/solution-finder')}
            sx={{ cursor: 'pointer', mt: 0.5 }}
          >
            <Typography variant='body2' fontWeight={500} color={KLAYO_COLORS.NeonBlueNB500}>
              {translate('exploreKlayoTeaser.cta')}
            </Typography>
            <Stack
              alignItems='center'
              justifyContent='center'
              sx={{
                '& svg path[fill="#9CA3AF"]': {
                  fill: 'currentColor',
                },
              }}
            >
              <ChevronRightIcon width={20} height={20} color={KLAYO_COLORS.NeonBlueNB500} />
            </Stack>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
